<div class="action-bar">
    <button class="action-btn" routerLink="/camera">
        <img src="assets/icons/camera-icon.svg" alt="Camera">
    </button>
    <button class="action-btn" routerLink="/share/select">
        <img src="assets/icons/upload-icon.svg" alt="Upload">
    </button>
    <button class="action-btn primary" routerLink="/chat">
        <img src="assets/icons/send-icon.svg" alt="Send">
    </button>
</div>